<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>地址类型：</p>
        <el-select v-model="addressIpt" filterable size="mini" style="width:150px">
          <el-option v-for="item in addressOption" :key="item.id" :label="item.classaName" :value="item.id"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>地址名称：</p>
        <el-input v-model="labelIpt" size="mini" style="width:150px" placeholder="请输入地址名称"/>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" type="index" width="50px"/>
          <el-table-column prop="addressTypeName" label="地址类型" align="center" width="200"/>
          <el-table-column prop="addressName" label="地址名称" align="center" width="250"/>
          <el-table-column prop="regionName" label="所在区域" align="center"/>
          <el-table-column prop="addressDetail" label="详细地址" align="center"/>
          <el-table-column prop="state" label="状态" align="center" width="150">
            <div slot-scope="scope">{{getState(scope.row.isEnable)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button v-if="scope.row.isEnable" size="mini" type="danger" @click="disableClick(scope.row.id)">禁用</el-button>
                <el-button v-else size="mini" type="primary" @click="enableClick(scope.row.id)">启用</el-button>
                <el-button size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <popup :title="dialogTitle" :show.sync="dialogVisible" width='550' center @close="dialogClose" :close-on-click-modal="false">
        <div class="depart">
          <el-form :model="addressData" label-width="95px" :rules="rules" ref="ruleForm">
            <el-form-item label="地址类型：" prop="type">
              <el-select v-model="addressData.type" size="mini" filterable style="width:100%" placeholder="请选择地址类型" value-key="id">
                <el-option v-for="item in typeOption" :key="item.id" :label="item.attrNm" :value="item"/>
              </el-select>
              <hr color="#F0F0F2"/>
            </el-form-item>
            <el-form-item label="地址名称：" prop="name">
              <el-input
                :style="'width:100%'"
                v-model="addressData.name"
                placeholder="请输入地址名称"
                autocomplete="off"
                size="small"
              />
              <hr color="#F0F0F2"/>
            </el-form-item>
            <el-form-item label="详细地址：" prop="address">
              <div style="display: flex;cursor: pointer;align-items: center;" @click="mapVisible=true">
                <el-input
                  :disabled="true"
                  style="width:90%;margin-right: 10px;"
                  v-model="addressData.address"
                  placeholder="点击选择详细地址"
                  autocomplete="off"
                  size="small"
                />
                <i class="el-icon-location"/>
              </div>
              <hr color="#F0F0F2"/>
            </el-form-item>
            <el-form-item label="所在区域：" prop="area">
              <el-cascader v-model="addressData.area" :options="regionList" style="width:100%" :props="{
                          expandTrigger: 'hover',
                          value: 'id',
                          label: 'cityName',
                          children: 'children',
                          multiple: false,
                        }" size="mini" collapse-tags filterable clearable placeholder="请选择所在区域" ref="areaCascader"
              />
              <hr color="#F0F0F2"/>
            </el-form-item>
            <div class="btnContainer">
              <el-button class="searchBtn" size="medium" :loading="addLoading" @click="addClick">确定</el-button>
              <el-button class="resetBtn" size="medium" @click="dialogClose">关闭</el-button>
            </div>
          </el-form>
        </div>
      </popup>
    </transition>
    <transition name="el-fade-in-linear">
      <popup width="850" title="详细地址" :show.sync="mapVisible" center>
        <web-map :useType="'select'" @close="mapClose" v-if="mapVisible" :address="addressData.address"/>
      </popup>
    </transition>
  </div>
</template>

<script>
import {
  addressDocPageList,
  addressDocAdd,
  addressDocIsEnable,
  addressDocDelete,
  addressDocUpdate,
} from "@/service/basicfile"
import { getParam,getRegionName} from "@/service/getData"
import {getSessionStore} from "@/config/mUtils";
import webMap from '@/components/map'
import popup from "@/components/popup";

export default {
  components: {
    webMap,
    popup,
  },

  data() {
    return {
      addressIpt:'',
      labelIpt:'',
      stateIpt:'',
      addressOption:[
        {id:'',classaName:'全部',},
      ],
      stateOption:[
        {value:'',label:'全部',},
        {value:1,label:'启动中',},
        {value:0,label:'禁用中',},
      ],
      typeOption:[],
      areaOption:[],
      tableLoad:false,
      TableDatas:[],
      page:1,
      size:10,
      total:0,
      dialogTitle:'',
      dialogVisible:false,
      addressData:{
        type:'',
        name:'',
        address:'',
        area:'',
      },
      rules:{
        type:[
          { required: true, message: '请选择地址类型', trigger: 'change' },
        ],
        name:[
          { required: true, message: '请输入地址名称', trigger: 'blur' },
        ],
        address:[
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        area:[
          { required: true, message: '请现在所在区域', trigger: 'change' },
        ],
      },
      regionList: [],
      mapVisible:false,
      addLoading: false,
    };
  },
  computed:{
    getState(){
      return function(state){
        switch(state) {
          case 0:
            return '禁用中'
          case 1:
            return '启用中'
        }
      };
    },
  },
  mounted() {
    this._addressDocPageList();
    this._getParam();
    this.regionList = JSON.parse(getSessionStore("areaList"));
  },
  methods: {
    mapClose(val, lnglat){
      console.log(val,'val')
      console.log(lnglat,'lnglat')
      this.addressData.address=val;
      this.addressData.lnglat=lnglat[0]+','+lnglat[1];
      this.mapVisible=false;
    },
    async _addressDocPageList(){
      const obj = {
        addressTypeId:this.addressIpt,
        addressName:this.labelIpt,
        isEnable:this.stateIpt,
        rows:this.size,
        page:this.page,
      }
      const res = await addressDocPageList(obj);
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total;
    },
    async _getParam(){
      // const res = await getParam('002');
      const res = await getParam({categoryCd:'address_type'});
      if(res.status !== 0) return this.$message.error(res.message);
      res.data.forEach(item=>{this.addressOption.push(item)})
      this.typeOption=res.data.map(item=>{
        return{
          attrNm:item.classaName,
          id:item.id
        }
      });
    },
    resetBtn(){
      this.addressIpt='';
      this.labelIpt='';
      this.stateIpt='';
    },
    searchBtn(){
      this.page = 1;
      this._addressDocPageList();
    },
    addBtn(){
      this.dialogVisible=true;
      this.dialogTitle='添加地址';
      this.addressData={};
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._addressDocPageList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._addressDocPageList();
    },
    disableClick(id){
      this.$confirm('确定要禁用当前地址吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await addressDocIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._addressDocPageList();
      }).catch(() => {});
    },
    enableClick(id){
      this.$confirm('确定要启用当前地址吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await addressDocIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._addressDocPageList();
      }).catch(() => {});
    },
    changeClick(item){
      const arr =[];
      item.regionId.split(',').forEach(item=>arr.push(Number(item)))
      this.addressData={
        ...item,
        type:{id:item.addressTypeId,attrNm:item.addressTypeName},
        name:item.addressName,
        address:item.addressDetail,
        area:arr,
        lnglat:item.coordinate,
      };
      this.dialogVisible=true;
      this.dialogTitle='修改地址';
    },
    dialogClose(){
      this.dialogVisible=false;
      this.addressData={
        type:'',
        name:'',
        address:'',
        area:'',
      };
      this.$refs.ruleForm.resetFields();
    },
    addClick(){
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let str='';
          this.addressData.area.forEach((area,index) =>{
            if(index !== this.addressData.area.length-1) str+=area+',';
            else str+=area
          });
          const res2 = await getRegionName(str);
          if(res2.status !== 0) return this.$message.error(res2.message);
          this.addLoading = true;
          const obj ={
            id:this.addressData.id,
            addressTypeId:this.addressData.type.id,
            addressTypeName:this.addressData.type.attrNm,
            addressName:this.addressData.name,
            addressDetail:this.addressData.address,
            regionId:str,
            regionName:res2.data,
            coordinate:this.addressData.lnglat,
          };
          const res = this.dialogTitle==='添加地址'?await addressDocAdd(obj):await addressDocUpdate(obj);
          this.addLoading = false;
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.dialogVisible=false;
          await this._addressDocPageList();
        } else return false;
      });
    },
    deleteClick(id){
      this.$confirm('确定要删除当前地址吗？', '提示', {
      confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await addressDocDelete(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._addressDocPageList();
      }).catch(() => {});
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  background-color: #fff;
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
        .el-table th>.cell{
          font-weight: 700!important;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .depart{
    width:100%;
    padding: 20px 10px;
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  .permissions{
    width:100%;
    padding: 20px 10px 20px 50px;
    .name{
      display:flex;
      align-items:center;
      margin-bottom: 20px;
      span{
        color: #2F1010;
      }
    }
    .content1{
      p{
        color: #2F1010;
      }
    }
    .tree{
      border:1px solid #D2D2D2;
      width: 400px;
      height: 280px;
      margin-left: 60px;
      border-radius: 5px;
      padding:5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }
    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }
    .el-dialog__headerbtn{
      top:9px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
